import { render } from "./TodoForm.vue?vue&type=template&id=9e411704"
import script from "./TodoForm.vue?vue&type=script&lang=js"
export * from "./TodoForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__